import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
  formatDateTimeStamp,
  getDistanceUsingHaversine,
  sortArrayOfObject,
} from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { FileUploadComponent } from '../../../../shared/components/file-upload/file-upload.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { PrompterComponent } from '../../../../shared/components/prompter/prompter.component';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { gTDB } from '../../../../shared/services/db';
import { DeviceInfoService } from '../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../shared/services/web-socket.service';
import { JobsService } from '../../jobs/jobs.service';
import { PagesService } from '../../pages.service';

@Component({
  selector: 'gtapp-update-events',
  templateUrl: './update-events.component.html',
  styleUrl: './update-events.component.scss',
  standalone: false,
})
export class UpdateEventsComponent implements OnInit, OnDestroy {
  @Input() detailType: any;

  @Input() details: any;
  @Output() emitData = new EventEmitter();
  @ViewChild('commentRef')
  commentRef!: TemplateRef<any>;

  dialogRef: any;

  uploadType: any;

  actualUploadFile: any;
  photoUploadedAt: any;
  fileExtension: any;
  distanceCalculation: boolean = false;

  //cp scan variables
  nearestCheckPointsList: any = [];
  dupCheckpointList: any = [];
  showCPFilterClose: boolean = false;

  //job update variables

  dupnearestJobList: any = [];
  nearestJobList: any = [];

  shiftsAfter12pm: any = [];
  showFilteredJobsAlso: boolean = false;

  eventAdditionalInfo: any = {};
  //client update variables
  nearestSiteList: any = [];
  dupnearestSiteList: any = [];

  sortKeys: any = [];
  videoDevices: any;

  webcamImageSource: any;
  newComment: any;
  selectedSite: any;
  handOverLogDraft: boolean = false;

  searchFilter: any;
  apidataUpdation: boolean = true;
  offlineMode: boolean = false;

  statusData: any = [];

  isGuardUser: boolean = false;

  promptData: any;

  groupUserCount = this.pageService.getGroupUserCount();

  webSocketSubscription: any;
  deviceInfoSubscription: any;

  // https://app.shortcut.com/sendem/story/12509/refactor-gps-lookup-logic
  currentUserLocation: any;

  removeStaleIndexDbJobData: any;

  constructor(
    private appService: AppService,
    private jobService: JobsService,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private ngZone: NgZone,
    private pageService: PagesService,
    private dataCheckService: DataCheckService,
    private viewContainerRef: ViewContainerRef,
    private toasterService: ToasterService,
    private deviceInfoService: DeviceInfoService,
    private webSocketService: WebSocketService,
  ) {
    this.isGuardUser = this.dataCheckService.isGuardUser();

    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('appStatus' in value) {
          this.offlineMode = !value?.appStatus;
          if (this.offlineMode) {
            setTimeout(() => {
              this.apidataUpdation = false;
            }, 200);
          }
        }
        if ('goBack' in value) {
          // from the back arrow btn at the top left of the screen
          this.goBack();
        }
      });

    let refreshJobListTimeOut: any;
    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (
          [
            'user_job_update',
            'wsn_response_job_update',
            'user_job_absolved',
            'wsn_run_sheet',
            'wsn_delete_runsheet',
          ].includes(event?.event)
        ) {
          if (refreshJobListTimeOut) clearTimeout(refreshJobListTimeOut);
          refreshJobListTimeOut = setTimeout(() => {
            this.getNearestJobs();
          }, 500);
        }
      });
  }
  ngOnDestroy(): void {
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.deviceInfoSubscription) this.deviceInfoSubscription?.unsubscribe();
  }

  async ngOnInit() {
    if (this.detailType === 'userPromptInfo' && this.details?.promptData?.id) {
      this.getNearestSiteList();
      this.promptData = JSON.parse(JSON.stringify(this.details?.promptData));
    } else if (this.detailType === 'scanCheckPoint') {
      this.getNearestCheckpoints();
    } else if (this.detailType === 'updateJob') {
      this.gtJobStatuses();
    } else if (this.detailType == 'addSitePhoto') {
      this.spinnerService.show();
      setTimeout(() => {
        this.openCamPopupDialog();
        this.getNearestSiteList();
        this.spinnerService.hide();
      }, 500);
    } else if (this.detailType == 'addSiteComment') {
      setTimeout(() => {
        this.openAddCommentTemplate();
        this.getNearestSiteList();
      }, 100);
    }

    this.pageService.miscSubjectParam.next({
      isOnEvent: this.detailType !== 'updateJob',
      updateEvent: this.detailType,
    });
  }

  goBack() {
    this.spinnerService.hide();
    this.emitData.emit();
  }

  async openScanCheckpointCamera(checkPoint: any) {
    this.dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'scanCheckpoint' },
    });

    this.dialogRef.afterClosed()?.subscribe((value: any) => {
      if (value && value !== 'error') {
        this.openUserPrompt(checkPoint, value);
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'ERROR: Unable to access your camera',
        });
      }
    });
  }
  getSortedPromtList(arrayList: any) {
    return sortArrayOfObject(arrayList, 'order', 'desc');
  }
  openUserPrompt(checkPoint: any, scannedRecord?: any) {
    if (checkPoint?.user_prompt_count <= 0) {
      this.scanCheckPoint(checkPoint, scannedRecord);
      return;
    }
    let promptResults: any = [];
    let dialogRefs: any = [];
    let counter = 0;
    this.getSortedPromtList(checkPoint?.user_prompts)?.forEach(
      (prompt: any) => {
        const dialogref = this.dialogService.open(PrompterComponent, {
          data: { promptData: prompt?.prompts },
        });
        dialogRefs.push(dialogref);
        dialogref.afterClosed().subscribe((value: any) => {
          if (value) {
            counter += 1;
            if (value?.length) {
              promptResults.push({
                data: value,
                prompt_data: { id: prompt?.id, name: prompt?.name },
              });
            }
            if (counter === checkPoint?.user_prompt_count) {
              this.scanCheckPoint(checkPoint, scannedRecord, promptResults);
            }
          } else {
            if (value === false) {
              dialogRefs?.forEach((dialogRef: any) => dialogRef?.close());
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: 'Checkpoint was not scanned',
              });
              this.clearEverythingGoBack();
            }
          }
        });
      },
    );
  }
  async scanCheckPoint(
    checkPoint: any,
    scannedRecord?: any,
    promptResults?: any,
  ) {
    this.actualUploadFile = scannedRecord?.actualFileUpload;
    if (!this.actualUploadFile) return;
    this.uploadType = scannedRecord?.uploadType;

    this.spinnerService.show('Uploading - Please Wait');

    let fileData: FormData = new FormData();
    fileData.append('file', this.actualUploadFile);
    fileData.append('check_point_id', checkPoint?.id);
    fileData.append('image_source', this.uploadType);
    if (promptResults?.length) {
      fileData.append('prompt_data', JSON.stringify(promptResults));
    }
    fileData.append(
      'checkpointDetail',
      JSON.stringify({
        name: checkPoint?.name,
        company: checkPoint?.company,
        site_name: checkPoint?.site_name,
      }),
    );

    if (this.details?.patrolRouteId) {
      fileData.append('patrol_route_id', this.details?.patrolRouteId);
    }
    if (this.details?.jobId) {
      fileData.append('job_id', this.details?.jobId);
    }

    const response: any = await this.appService.backUpAndUploadUpdate(
      `patrol/scan_checkpoint`,
      fileData,
      {},
      'POST',
      this.currentUserLocation,
    );

    this.clearEverythingGoBack(response);
    this.dialogRef.close();
    this.spinnerService.hide();
  }

  async updateSite(site: any) {
    this.selectedSite = site;
    if (this.detailType == 'addSiteComment') {
      this.callUploadApi('Uploading Comment');
    } else if (this.detailType == 'addSitePhoto') {
      this.callUploadApi();
    } else if (
      this.detailType == 'userPromptInfo' &&
      this.promptData?.prompts?.length
    ) {
      const dialogRef = this.dialogService.open(PrompterComponent, {
        data: { promptData: this.promptData?.prompts },
      });
      const value = await firstValueFrom(dialogRef.afterClosed());
      if (value?.length) {
        this.callUploadApi('Uploading Data', value);
      } else {
        this.goBack();
      }
    } else {
      this.goBack();
    }
  }
  openEventPage(event: any) {
    this.goBack();
    const cachedJobIds = JSON.parse(
      localStorage.getItem(btoa('indexedDbJobIdsToKeep')) || '[]',
    );

    if (this.offlineMode && !cachedJobIds?.includes(String(event.event_id))) {
      this.toasterService.setMessage({
        successMessage: '',
        errorMessage:
          'Unable to fetch details from server. Please try again later',
      });
      return;
    }
    sessionStorage.removeItem(btoa('cachedHomeJobIdsList'));
    if (event?.job_type_name.toLowerCase() === 'patrol') {
      this.router.navigate(['/view-route', { rKey: String(event.event_id) }]);
    } else if (event?.job_type_key === -1) {
      this.router.navigate([
        '/view-runsheet',
        { rKey: String(event.event_id) },
      ]);
    } else {
      window.localStorage.setItem('urlId', event.event_id);
      this.router.navigate([`/job-detail/${event.job_id}`], {
        queryParams: { jId: event?.event_id },
      });
    }
  }
  clearEverythingGoBack(response?: any) {
    if (response) {
      if (response?.status == 'success') {
        this.toasterService.setMessage({
          successMessage: this.offlineMode
            ? 'Action Queued'
            : response?.message,
          errorMessage: '',
        });
      } else {
        this.toasterService.setMessage({
          errorMessage: response?.message,
          successMessage: '',
        });
      }
    }
    if (this.handOverLogDraft) {
      // to minimize unnecessary calls to backend to check for drafts
      sessionStorage.setItem('handOverLogUpdate', '1');
    }

    this.searchFilter = null;

    this.selectedSite = null;
    this.newComment = null;
    this.goBack();
    this.spinnerService.hide();
  }

  openAddCommentTemplate() {
    this.dialogRef = this.dialogService.open(
      this.commentRef,
      {},
      this.viewContainerRef,
    );

    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value == 'close') {
        this.clearEverythingGoBack();
      }
    });
  }

  openCamPopupDialog() {
    this.dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'updateClient' },
    });

    this.dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.actualUploadFile = value.actualFileUpload;
        this.uploadType = value?.uploadType;
        this.newComment = value.newComment;
        this.handOverLogDraft = value?.handOverLogDraft;
        this.photoUploadedAt = value?.uploadedAt;
        this.fileExtension = value?.fileExtension;
      } else if (value == 'error') {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: 'ERROR: Unable to access your camera',
        });
      } else {
        this.goBack();
      }
    });
  }

  async getFormattedData(dupList: any, gps: any, source = 'cp') {
    return new Promise(async (resolve) => {
      dupList?.forEach((item: any) => {
        item.hDistance =
          item?.latitude && item?.longitude
            ? Number(
                getDistanceUsingHaversine(
                  gps?.lat,
                  item?.latitude,
                  gps?.lon,
                  item?.longitude,
                ),
              )
            : 0;
      });

      if (source == 'cp') {
        dupList = await this.formatCPList(dupList);
        this.dupCheckpointList = dupList;
      } else {
        this.dupnearestSiteList = dupList;
      }

      resolve(sortArrayOfObject(dupList, 'hDistance', 'asc'));
    });
  }
  async formatCPList(dupList: any) {
    return new Promise((resolve) => {
      resolve(dupList?.filter((cp: any) => cp?.hDistance <= cp?.max_distance));
    });
  }

  fetchLocationAndCalculateDistance(dupList: any, source = 'cp') {
    if (dupList?.length > 0) {
      this.distanceCalculation = true;
      this.deviceInfoService.getGpsCoordinates().then(async (gps: any) => {
        if (gps?.lat != null && gps?.lon != null) {
          this.currentUserLocation = gps;
        }

        let sortedList: any = await this.getFormattedData(dupList, gps, source);
        if (source === 'cp') {
          this.nearestCheckPointsList = sortedList;
        } else {
          this.nearestSiteList = sortedList;
        }

        this.distanceCalculation = false;
      });
    }
  }
  async keepRemoveIndexedDbJobData(idSet: any) {
    // send a list of active jobIds to service worker
    //so that the db doesn't have to keep stale jobs in it
    // need to keep only these jobs in the indexed db
    // get list of existing jobs in index db

    const idsToRemove = new Set();
    const idsToKeep = new Set();

    const cachedShortPaths = ['job_', 'runsheet_', 'c_patrol_'];
    await gTDB.cachedData
      .where('shortPath')
      .startsWithAnyOf(cachedShortPaths)
      .each((job, cursor) => {
        let shortPath = job?.shortPath;
        const runsheetId = job?.jobDetailData?.run_sheet?.id;

        const matchedPrefix = cachedShortPaths?.find((item: any) =>
          shortPath?.startsWith(item),
        );
        if (matchedPrefix) {
          shortPath = shortPath?.slice(matchedPrefix?.length);
          const keepJob =
            idSet.has(shortPath) || (runsheetId && idSet.has(runsheetId));
          if (keepJob) {
            idsToKeep.add(shortPath);
          } else {
            idsToRemove.add(cursor.primaryKey);
          }
        }
      });
    localStorage.setItem(
      btoa('indexedDbJobIdsToKeep'),
      JSON.stringify([...idsToKeep]),
    );

    if (idsToRemove.size) {
      await gTDB.cachedData.bulkDelete([...idsToRemove]);
    }
  }
  areSetsEqual(setA: any, setB: any) {
    if (setA.size !== setB.size) return false;

    for (const item of setA) {
      if (!setB.has(item)) return false;
    }

    return true;
  }
  formatNewApiData(eventData: any) {
    if (eventData?.shortPath) {
      if (eventData?.shortPath == '/api/job/') {
        if (eventData?.data) this.formatJobStatuses(eventData);
      } else {
        this.ngZone.run(() => {
          setTimeout(() => {
            this.apidataUpdation = false;
            this.pageService.miscSubjectParam.next({
              addPhotoClientCount: {
                apidataUpdation: this.apidataUpdation,
                clientCount: this.nearestSiteList?.length,
              },
            });
          }, 100);
        });

        if (eventData?.shortPath == '/api/job/list_nearest/') {
          this.formatNearestJobs(eventData?.data || []);

          this.eventAdditionalInfo = eventData?.additional_info;
          let idListSet = new Set(
            (eventData?.data || [])?.map((job: any) => job?.event_id),
          );
          const cachedHomeJobIdsList: any = new Set(
            JSON.parse(
              sessionStorage.getItem(btoa('cachedHomeJobIdsList')) || '[]',
            ),
          );
          let isSame = this.areSetsEqual(cachedHomeJobIdsList, idListSet);

          if (!isSame) {
            sessionStorage.setItem(
              btoa('cachedHomeJobIdsList'),
              JSON.stringify([...idListSet]),
            );
            clearTimeout(this.removeStaleIndexDbJobData);
            this.removeStaleIndexDbJobData = setTimeout(() => {
              this.keepRemoveIndexedDbJobData(idListSet);
            }, 3000);
          }
        }
        if (eventData?.shortPath == '/api/site/list_nearest/') {
          this.nearestSiteList = this.filterPatrolEvents(
            eventData?.data,
            'client',
          );
          this.dupnearestSiteList = this.nearestSiteList;
          this.fetchLocationAndCalculateDistance(
            this.dupnearestSiteList,
            'site',
          );
        }
        if (eventData?.shortPath == '/api/check_point/list_nearest/') {
          this.dupCheckpointList = this.filterPatrolEvents(eventData?.data);
          this.nearestCheckPointsList = this.dupCheckpointList;
          this.fetchLocationAndCalculateDistance(this.dupCheckpointList);
        }
      }
    }
  }
  formatNearestJobs(jobListData: any) {
    const tenAM = new Date();
    tenAM.setHours(10, 0, 0, 0);
    const twelvePM = new Date();
    twelvePM.setHours(12, 0, 0, 0);

    const currentTime = new Date().getTime();

    this.shiftsAfter12pm = [];
    this.nearestJobList = [];
    this.dupnearestJobList = JSON.parse(JSON.stringify(jobListData));

    this.dupnearestJobList?.forEach((job: any) => {
      if (job?.schedule_details?.start_time) {
        const startDateTime = this.getScheduleStartEndDateTime(job);
        if (
          currentTime < tenAM.getTime() &&
          startDateTime &&
          startDateTime.getTime() > twelvePM.getTime()
        ) {
          // filter the jobs only if current time is less thatn 10 am of that day
          this.shiftsAfter12pm.push(job);
        } else {
          this.nearestJobList.push(job);
        }
      } else {
        this.nearestJobList.push(job);
      }
    });
  }

  filterPatrolEvents(eventData: any, eventType: string = 'checkpoint') {
    if (!this.details?.filterPatrolData) return eventData;
    if (eventType === 'checkpoint') {
      return eventData?.filter((item: any) =>
        this.details?.filterPatrolData?.checkpoint?.includes(item?.id),
      );
    } else {
      return eventData?.filter(
        (item: any) =>
          (this.details?.filterPatrolData?.company?.includes(item?.id) &&
            item?.default) ||
          (item?.site_id &&
            this.details?.filterPatrolData?.site?.includes(item?.site_id)),
      );
    }
  }

  // checkpoints section

  getNearestCheckpoints() {
    let body: any = {};
    // if (this.details?.patrolRouteId) {
    //   body.patrol_route_id = this.details?.patrolRouteId;
    // }
    this.spinnerService.show('Getting Checkpoints Near You');
    this.jobService
      .getNearestCheckpointList(body)
      .subscribe((response: any) => {
        if (response['status'] === 'success') {
          if (response?.isLatest) {
            this.formatNewApiData(response);
            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
            this.dupCheckpointList = this.filterPatrolEvents(response?.data);
            this.nearestCheckPointsList = this.dupCheckpointList;
            this.fetchLocationAndCalculateDistance(this.dupCheckpointList);
            if (response?.message) {
              this.toasterService.setMessage({
                successMessage: response?.message,
                errorMessage: '',
              });
            }
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }

  onCPFilterApply(event: any) {
    if (event?.target?.value?.length === 0) {
      this.onCPClearFilter();
    } else {
      const searchString = event?.target?.value?.toLowerCase();
      this.nearestCheckPointsList = this.dupCheckpointList?.filter(
        (item: any) =>
          item?.name?.toLowerCase()?.includes(searchString) ||
          item?.company?.toLowerCase()?.includes(searchString) ||
          item?.site_name?.toLowerCase()?.includes(searchString) ||
          item?.full_address?.toLowerCase()?.includes(searchString),
      );
    }
  }
  onCPClearFilter() {
    this.searchFilter = null;
    this.nearestCheckPointsList = this.dupCheckpointList;
    this.showCPFilterClose = false;
  }

  // site update section
  getNearestSiteList() {
    let body: any = {};

    this.jobService.getNearesSiteList(body).subscribe((response: any) => {
      if (response['status'] === 'success') {
        if (response?.isLatest) {
          this.formatNewApiData(response);
        } else {
          this.nearestSiteList = this.filterPatrolEvents(
            response?.data,
            'client',
          );
          this.dupnearestSiteList = this.nearestSiteList;
          this.fetchLocationAndCalculateDistance(
            this.dupnearestSiteList,
            'site',
          );
          this.pageService.miscSubjectParam.next({
            addPhotoClientCount: {
              apidataUpdation: this.apidataUpdation,
              clientCount: this.nearestSiteList?.length,
            },
          });
        }
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response?.message,
        });
      }
    });
  }

  onFilterSitesApply(event: any) {
    if (event?.target?.value?.length === 0) {
      this.onClearSitesFilter();
    } else {
      const searchString = event?.target?.value?.toLowerCase();

      this.nearestSiteList = this.dupnearestSiteList?.filter(
        (item: any) =>
          item?.full_address?.toLowerCase().includes(searchString) ||
          item?.company_name?.toLowerCase().includes(searchString) ||
          item?.site_name?.toLowerCase().includes(searchString) ||
          item?.site_address?.toLowerCase().includes(searchString),
      );
    }
  }
  onClearSitesFilter() {
    this.searchFilter = null;
    this.nearestSiteList = this.dupnearestSiteList;
  }

  formatJobStatuses(response: any) {
    this.statusData = response?.statuses;

    this.statusData.push({
      id: '0',
      name: 'Closed',
      additional_info: {
        style: {
          snubbed: {
            'color': 'var(--color-basic-1100)',
            'background-color': 'var(--color-basic-100)',
            'border-color': 'var(--color-basic-1100)',
            'border': '1px solid var(--color-basic-1100)',
          },
        },
      },
    });
    this.statusData = JSON.parse(JSON.stringify(this.statusData));
  }
  gtJobStatuses() {
    this.getNearestJobs();
    this.jobService.getJobParams().subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.formatJobStatuses(response);
      }
    });
  }

  getNearestJobs() {
    this.jobService
      .getNearestJobs({ time_offset: new Date().getTimezoneOffset() })
      .subscribe((response: any) => {
        if (response['status'] === 'success') {
          if (response?.isLatest) {
            this.formatNewApiData(response);
          } else {
            this.eventAdditionalInfo = response?.additional_info;
            this.formatNearestJobs(response?.data || []);
          }
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response?.message,
          });
        }
      });
  }
  getJobCardDetailInfo(statusDataDetails: any) {
    return [
      {
        name: 'status_name',
        conditionalRowStyle: (row: any) => {
          if (row?.status_name) {
            let style: any = { 'float': 'right', 'font-size': 'small' };

            statusDataDetails?.forEach((element: any) => {
              if (element.name === row.status_name) {
                style = {
                  'color': `${element.additional_info?.style?.snubbed?.color}`,
                  'background-color': `${element.additional_info?.style?.snubbed['background-color']}`,
                  'border': '1px solid',
                  'border-radius': '5px',
                  'padding': '0 0.5rem',
                  'float': 'right',
                  'font-size': 'small',
                };
              }
            });

            return style;
          } else {
            return { 'float': 'right', 'font-size': 'small' };
          }
        },
      },

      {
        nestedValue: (row: any) => {
          if (row?.response_type_name) {
            return row?.job_type_name + ' - ' + row?.response_type_name;
          } else {
            return row?.job_type_name;
          }
        },
        cardRowStyle: { 'font-weight': 'bold' },
      },

      {
        name: 'site_name',
        cardRowStyle: { 'font-weight': 'bold' },
      },
      {
        nestedValue: (row: any) => {
          if (
            row?.job_type_name?.toLowerCase() === 'patrol' &&
            row?.checkpoints
          ) {
            return row?.checkpoints_remaining > 0
              ? `Checkpoint${row?.checkpoints == 1 ? '' : 's'} to Scan: ${
                  row?.checkpoints_remaining
                } of ${row?.checkpoints}`
              : 'All Checkpoints Scanned';
          }
          return;
        },
        conditionalRowStyle: (row: any) => {
          if (row?.job_type_name?.toLowerCase() === 'patrol') {
            return {};
          }
          return {};
        },
      },

      {
        name: 'site_address',
        cardRowStyle: { 'font-size': 'small' },
      },

      {
        nestedValue: (row: any) => {
          if (
            row?.last_modified_at &&
            !(
              row?.status == 'Closed' ||
              row?.status_identity == 2 ||
              row?.status_identity == 3 ||
              row?.job_type_name?.toLowerCase() === 'patrol'
            )
          ) {
            return (
              'LAST UPDATE: ' +
              String(
                formatDateTimeStamp(
                  row?.last_modified_at,
                  'd MMM y HH:mm',
                  'en_US',
                ),
              )
            );
          }
          return '';
        },
        conditionalRowStyle: (row: any) => {
          return { 'font-size': 'small' };
        },
      },
      {
        nestedValue: (row: any) => {
          if (row?.external_job_id) {
            return `${row?.job_id} [${row?.external_job_id}]`;
          } else {
            return row?.job_id;
          }
        },
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        nestedValue: (row: any) => {
          if (!row?.schedule_details?.start_time) return null;
          const startDateTime = this.getScheduleStartEndDateTime(row);
          if (startDateTime?.getTime() < new Date().getTime()) {
            return `Shift Started: ${formatDateTimeStamp(
              startDateTime,
              'HH:mm',
              'en_US',
            )}`;
          } else {
            return `Shift Start: ${formatDateTimeStamp(
              startDateTime,
              'HH:mm',
              'en_US',
            )}`;
          }
        },
        conditionalRowStyle: (row: any) => {
          if (!row?.schedule_details?.start_time) return {};
          const startDateTime = this.getScheduleStartEndDateTime(row);
          if (startDateTime?.getTime() < new Date().getTime()) {
            return {
              'align-items': 'center',
              'display': 'flex',
              'justify-content': 'center',
              'font-size': 'small',
              'color': 'var(--bs-secondary)',
              'padding': '0.5rem',
            };
          } else {
            return {
              'align-items': 'center',
              'display': 'flex',
              'justify-content': 'center',
              'font-size': 'small',
              'color': 'var(--bs-primary)',
              'padding': '0.5rem',
            };
          }
        },
      },
    ];
  }
  clearAndFocusTextBox(elementId: string) {
    this.newComment = '';
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  getScheduleStartEndDateTime(row: any) {
    return new Date(
      (row?.schedule_details?.event_date
        ? row?.schedule_details?.event_date
        : row?.schedule_details?.start_day) +
        ' ' +
        row?.schedule_details?.start_time,
    );
  }
  async callUploadApi(
    spinnerMessage: string = 'Uploading - Please Wait',
    promptResults?: any,
  ) {
    this.spinnerService.show(spinnerMessage);
    let fileData: FormData = new FormData();
    let params: any = {};

    if (this.newComment) {
      fileData.append('comment', this.newComment);
    }

    if (this.actualUploadFile) {
      fileData.append('file', this.actualUploadFile);
      if (this.actualUploadFile?.type?.startsWith('video/')) {
        params['video_upload'] = 1;
      }
      fileData.append('image_source', this.uploadType);
      if (this.fileExtension) {
        fileData.append('file_extension', `.${this.fileExtension}`);
      }
      if (this.photoUploadedAt) {
        fileData.append('updated_at', this.photoUploadedAt);
      }
    }

    if (this.promptData?.id && promptResults) {
      fileData.append('user_prompt_id', this.promptData?.id);
      fileData.append(
        'prompt_data',
        JSON.stringify([
          {
            data: promptResults,
            prompt_data: {
              id: this.promptData?.id,
              name: this.promptData?.name,
            },
          },
        ]),
      );
    }

    fileData.append('company_id', this.selectedSite?.id);
    fileData.append('company', this.selectedSite?.company_name);
    fileData.append('site_name', this.selectedSite?.site_name);
    fileData.append('site_id', this.selectedSite?.site_id);

    if (this.details?.patrolRouteId) {
      fileData.append('patrol_route_id', this.details?.patrolRouteId);
    }
    if (this.handOverLogDraft)
      fileData.append('hand_over_log_draft', String(this.handOverLogDraft));

    const response: any = await this.appService.backUpAndUploadUpdate(
      `patrol/add_update`,
      fileData,
      params,
      'POST',
      this.currentUserLocation,
    );

    this.clearEverythingGoBack(response);

    this.spinnerService.hide();
  }
}
